import { MarketplaceCategoriesWrapper } from '../../components'

export default function MarketplaceCategoriesPage() {
  return <MarketplaceCategoriesWrapper />
}
